module.exports = __webpack_public_path__ + "img/snow_fall_00023.4ce27cb4.png";